export function isNullOrUndefined(value?: unknown): boolean {
  return value === null || value === undefined;
}
